module.exports = __webpack_public_path__ + "static/part-4-f800638504cdf371a12947fc31d52030.svg";